export default {
	default: [''],
	leftLabel: ['dropdown--left-label']
};
